import Image from 'next/image';

interface ServiceCardProps {
  title: string;
  description: string;
  icon?: string;
  variant?: 'primary' | 'secondary';
  bgColor?: string;
  textColor?: string;
  iconBg?: string;
  shadow?: string;
}

export default function ServiceCard({
  title,
  description,
  icon,
  variant = 'secondary',
  bgColor = 'bg-white',
  textColor = 'text-black',
  iconBg = 'bg-gray-200',
  shadow = 'shadow-md'
}: ServiceCardProps) {
  return (
    <div data-component-id="src\components\ui\ServiceCard.tsx:25:4" data-component-path="src\components\ui\ServiceCard.tsx" data-component-line="25" data-component-file="ServiceCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`service-card ${variant === 'primary' ? 'service-card-primary' : 'service-card-secondary'} ${bgColor} ${textColor} ${shadow} p-6 rounded-lg`}
    >
      {icon && (
        <div data-component-id="src\components\ui\ServiceCard.tsx:29:8" data-component-path="src\components\ui\ServiceCard.tsx" data-component-line="29" data-component-file="ServiceCard.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`service-icon ${iconBg} p-4 rounded-full mb-4 flex justify-center items-center`}>
          <Image data-component-id="src\components\ui\ServiceCard.tsx:30:10" data-component-path="src\components\ui\ServiceCard.tsx" data-component-line="30" data-component-file="ServiceCard.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Aicon%5D%22%2C%22className%22%3A%22service-icon-image%22%7D"
            src={icon}
            alt={`${title} icon`}
            width={80}
            height={80}
            className="service-icon-image"
          />
        </div>
      )}
      <h4 data-component-id="src\components\ui\ServiceCard.tsx:39:6" data-component-path="src\components\ui\ServiceCard.tsx" data-component-line="39" data-component-file="ServiceCard.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22service-title%20text-xl%20font-semibold%20mb-2%22%7D" className="service-title text-xl font-semibold mb-2">{title}</h4>
      <p data-component-id="src\components\ui\ServiceCard.tsx:40:6" data-component-path="src\components\ui\ServiceCard.tsx" data-component-line="40" data-component-file="ServiceCard.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22service-description%22%7D" className="service-description">{description}</p>
    </div>
  );
}